export const gameContextDefaults = {
  mostRecentMovie: {
    guess: "",
    type: "",
    year: "",
  },
  changeMostRecentActor: () => [],
  mostRecentActor: {
    guess: "",
    type: "",
    year: "",
  },
  changeMostRecentMovie: () => [],
};
